
(function () {
  if (window.bcDeliveryReady) return;
  window.bcDeliveryReady = true;

  // CONFIGURACIÓN
  const CUTOFF_HOUR = 13;
  const DEFAULT_DAYS = 0;
  const TIME_ZONE = 'Europe/Madrid';

  // IDIOMA DE SHOPIFY
  const lang = (document.documentElement.lang || 'es')
    .toLowerCase()
    .slice(0, 2);

  const translations = {
    es: {
      fixed: 'Envío estimado el ',
      before: 'Haz tu pedido antes de ',
      after: ' para envío el día ',
      noticeTitle: 'Envío conjunto del pedido',
      noticeBefore: 'Tu pedido se enviará completo a partir del ',
      noticeAfter: ', cuando todos los artículos estén disponibles.',
      noticeSmall: 'Si necesitas recibir algún artículo antes, consúltanos las opciones de envío por separado.'
    },
    en: {
      fixed: 'Estimated dispatch from ',
      before: 'Order within ',
      after: ' for dispatch on ',
      noticeTitle: 'Combined order shipping',
      noticeBefore: 'Your complete order is expected to ship from ',
      noticeAfter: ', once all items are available.',
      noticeSmall: 'If you need an item sooner, contact us to discuss separate shipping options.'
    },
    fr: {
      fixed: 'Expédition prévue à partir du ',
      before: 'Commandez dans ',
      after: ' pour une expédition le ',
      noticeTitle: 'Expédition groupée de la commande',
      noticeBefore: 'Votre commande complète sera expédiée à partir du ',
      noticeAfter: ', lorsque tous les articles seront disponibles.',
      noticeSmall: 'Si vous souhaitez recevoir un article plus tôt, contactez-nous pour connaître les possibilités d’expédition séparée.'
    },
    de: {
      fixed: 'Voraussichtlicher Versand ab dem ',
      before: 'Bestelle innerhalb von ',
      after: ' für einen Versand am ',
      noticeTitle: 'Gemeinsamer Versand der Bestellung',
      noticeBefore: 'Deine gesamte Bestellung wird voraussichtlich ab dem ',
      noticeAfter: ' versendet, sobald alle Artikel verfügbar sind.',
      noticeSmall: 'Wenn du einen Artikel früher benötigst, kontaktiere uns bezüglich eines getrennten Versands.'
    }
  };

  const t = translations[lang] || translations.es;

  // FESTIVOS DE GIJÓN 2026-2027
  const holidays = new Set([
    '2026-01-01', '2026-01-06',
    '2026-02-17', '2026-04-02',
    '2026-04-03', '2026-05-01',
    '2026-06-29', '2026-08-15',
    '2026-09-08', '2026-10-12',
    '2026-11-02', '2026-12-07',
    '2026-12-08', '2026-12-25',

    '2027-01-01', '2027-01-06',
    '2027-02-09', '2027-03-25',
    '2027-03-26', '2027-05-01',
    '2027-06-29', '2027-08-16',
    '2027-09-08', '2027-10-12',
    '2027-11-01', '2027-12-06',
    '2027-12-08', '2027-12-25'
  ]);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  function madridNow() {
    const result = {};

    for (const part of formatter.formatToParts(new Date())) {
      if (part.type !== 'literal') {
        result[part.type] = Number(part.value);
      }
    }

    return result;
  }

  function dateUTC(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d));
  }

  function addDays(date, count) {
    const result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + count);
    return result;
  }

  function isWorkingDay(date) {
    const day = date.getUTCDay();

    if (day === 0 || day === 6) return false;

    return !holidays.has(
      date.toISOString().slice(0, 10)
    );
  }

  function nextWorkingDay(date) {
    let result = date;

    while (!isWorkingDay(result)) {
      result = addDays(result, 1);
    }

    return result;
  }

  function addWorkingDays(date, days) {
    let result = date;

    for (let i = 0; i < days; i++) {
      result = nextWorkingDay(addDays(result, 1));
    }

    return result;
  }

  function formatDate(date) {
    return [
      String(date.getUTCDate()).padStart(2, '0'),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      date.getUTCFullYear()
    ].join('/');
  }

  function getContext() {
    const now = madridNow();

    const today = dateUTC(
      now.year,
      now.month,
      now.day
    );

    const todayISO = [
      now.year,
      String(now.month).padStart(2, '0'),
      String(now.day).padStart(2, '0')
    ].join('-');

    const secondsNow =
      now.hour * 3600 +
      now.minute * 60 +
      now.second;

    const cutoffSeconds = CUTOFF_HOUR * 3600;
    let deadline = today;

    if (
      !isWorkingDay(deadline) ||
      secondsNow >= cutoffSeconds
    ) {
      deadline = nextWorkingDay(
        addDays(deadline, 1)
      );
    }

    const remaining =
      (deadline.getTime() - today.getTime()) / 1000 +
      cutoffSeconds -
      secondsNow;

    return {
      todayISO,
      deadline,
      hours: Math.floor(remaining / 3600),
      minutes: Math.floor((remaining % 3600) / 60)
    };
  }

  // MISMO CÁLCULO PARA PRODUCTO Y CARRITO
  function calculateDelivery(block, context) {
    const fixedDate = block.dataset.date || '';
    const rawDays = block.dataset.days || '';

    // Fecha manual futura
    if (fixedDate && fixedDate >= context.todayISO) {
      const [y, m, d] = fixedDate.split('-').map(Number);
      const shippingDate = dateUTC(y, m, d);

      return {
        date: shippingDate,
        message: t.fixed + formatDate(shippingDate)
      };
    }

    // Preparación personalizada o 2 días por defecto
    const parsedDays =
      rawDays === '' ? DEFAULT_DAYS : Number(rawDays);

    const days =
      Number.isFinite(parsedDays) && parsedDays >= 0
        ? Math.floor(parsedDays)
        : DEFAULT_DAYS;

    const shippingDate = addWorkingDays(
      context.deadline,
      days
    );

    const countdown =
      String(context.hours).padStart(2, '0') +
      ' h ' +
      String(context.minutes).padStart(2, '0') +
      ' m';

    const isToday =
  shippingDate.toISOString().slice(0, 10) === context.todayISO;

const todayText = {
  es: ' para envío hoy',
  en: ' for dispatch today',
  fr: " pour une expédition aujourd'hui",
  de: ' für einen Versand heute'
};

return {
  date: shippingDate,
  message: isToday
    ? t.before + countdown + (todayText[lang] || todayText.es)
    : t.before + countdown + t.after + formatDate(shippingDate)
};
  }

  function updateDelivery() {
    const context = getContext();

    // FICHA DE PRODUCTO Y CARRITO
    document.querySelectorAll(
      '.bc-delivery-estimate, [data-bc-delivery]'
    ).forEach(block => {
      const output = block.querySelector(
        '.bc-delivery-estimate__text, ' +
        '.bc-cart-delivery__text'
      );

      if (!output) return;

      const result = calculateDelivery(block, context);

      if (output.textContent !== result.message) {
        output.textContent = result.message;
      }
    });

    // AVISO DE ENVÍO CONJUNTO
    const notice = document.getElementById(
      'bc-cart-shipping-notice'
    );

    const noticeDate = document.getElementById(
      'bc-cart-shipping-date'
    );

    if (!notice || !noticeDate) return;

    const cartBlocks = document.querySelectorAll(
      'main-cart [data-bc-delivery]'
    );

    const dates = Array.from(cartBlocks).map(
      block => calculateDelivery(
        block,
        context
      ).date.getTime()
    );

    const uniqueDates = new Set(dates);

    if (
      dates.length > 1 &&
      uniqueDates.size > 1
    ) {
      const latestDate = new Date(Math.max(...dates));
      const formattedDate = formatDate(latestDate);

      const title = notice.querySelector(
        '.bc-cart-shipping-notice__title'
      );
      const before = notice.querySelector(
        '.bc-cart-shipping-notice__before'
      );
      const after = notice.querySelector(
        '.bc-cart-shipping-notice__after'
      );
      const small = notice.querySelector(
        '.bc-cart-shipping-notice__small'
      );

      if (title && title.textContent !== t.noticeTitle) {
        title.textContent = t.noticeTitle;
      }

      if (before && before.textContent !== t.noticeBefore) {
        before.textContent = t.noticeBefore;
      }

      if (after && after.textContent !== t.noticeAfter) {
        after.textContent = t.noticeAfter;
      }

      if (small && small.textContent !== t.noticeSmall) {
        small.textContent = t.noticeSmall;
      }

      if (noticeDate.textContent !== formattedDate) {
        noticeDate.textContent = formattedDate;
      }

      if (notice.hidden) notice.hidden = false;

    } else if (!notice.hidden) {
      notice.hidden = true;
    }
  }

  // INICIALIZACIÓN OPTIMIZADA
  function initialize() {
    updateDelivery();
   // Detectar cambios dinámicos de producto en Wildpeak.
    const productObserver = new MutationObserver((mutations) => {
      const hasNewDeliveryBlock = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(node =>
          node.nodeType === 1 &&
          (
            node.matches?.('.bc-delivery-estimate') ||
            node.querySelector?.('.bc-delivery-estimate')
          )
        )
      );

      if (hasNewDeliveryBlock) {
        updateDelivery();
      }
    });

    productObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
    // Una actualización cada 30 segundos
    setInterval(() => {
      if (!document.hidden) updateDelivery();
    }, 30000);

    document.addEventListener(
      'visibilitychange',
      () => {
        if (!document.hidden) updateDelivery();
      }
    );

    // Observar solamente el carrito completo
    const mainCart = document.querySelector('main-cart');

    if (!mainCart || !mainCart.parentElement) return;

    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;

      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        updateDelivery();
      });
    });

    observer.observe(mainCart.parentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
